import { render, staticRenderFns } from "./TipificarCobranza.vue?vue&type=template&id=a6e9f8e8&scoped=true"
import script from "./TipificarCobranza.vue?vue&type=script&lang=js"
export * from "./TipificarCobranza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e9f8e8",
  null
  
)

export default component.exports